import HttpService from "./HttpService";
const API_ENDPOINT = "/ess";

const MyAssetService = {
  async getAssets() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-asset`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getServices() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-service`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getCards() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-card`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getInventories() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-inventory`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default MyAssetService;
